/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_TOKEN_DETAILS = gql`
  query GetToken($filter: UniqTokenFilterInput) {
    getToken(filter: $filter) {
      band {
        name
        id
      }
      isGroup
      isVipToken
      isMagicToken
      tokenKey
      comments
      boxes {
        collectorProfile {
          collectorType
          name
        }
        costumeID
        gender
        isVIP
        isMagic
        masqID
        section
        sectionOptType
        user {
          phoneNumbers {
            number
          }
          email
          fullName
        }
      }
    }
  }
`;
